var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transactions',{attrs:{"transaction-class":_vm.transactionClass,"verbose-name":"Facture","verbose-name-plural":"Factures","ressource":"invoices","additional-params":{ expense: _vm.$route.params.expense },"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }